<template>
    <div v-if="hasFieldToDisplay()">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon> Général
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <v-text-field v-if="hasField('OFFER_NAME')" v-model="provider.name" label="Nom de votre activité"
                autocomplete="new-offer-name" outlined>
            </v-text-field>

            <div v-for="content in provider.contents">
                <v-textarea v-if="hasField('DESC_COURT_' + content.language.code)" class="textarea mb-5"
                    v-model="content.description" counter :maxlength="content.language.code === 'fr'? '255' : null" outlined>
                    <template v-slot:label>
                        Description courte <img :src="'/images/flags/' + content.language.code + '.png'" height="20px">
                    </template>
                </v-textarea>
            </div>

            <div v-for="content in provider.contents">
                <v-textarea v-if="hasField('DESC_LONG_' + content.language.code)" class="textarea"
                    v-model="content.description_long" outlined>
                    <template v-slot:label>
                        Description longue <img :src="'/images/flags/' + content.language.code + '.png'" height="20px">
                    </template>
                </v-textarea>
            </div>

            <v-autocomplete v-if="hasFamilyElement('ModePaiement') &&
            (moyenPaiements.length > 0 || !getField('ModePaiement').skipped)"
                            :value="moyenPaiements" :items="getFamilyByCode('ModePaiement')" chips
                @change="updateOrDeleteElement($event, 'moyenPaiements')" deletable-chips
                label="Moyens de paiement acceptés" item-text="label" return-object multiple outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('ModePaiement') && moyenPaiements.length === 0 &&
             getField('ModePaiement').skipped"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Moyens de paiement acceptés"
                            outlined>
            </v-autocomplete>

            <v-autocomplete v-if="hasFamilyElement('Langue') &&
            (langues.length > 0 || !getField('Langue').skipped)"
                            :value="langues" :items="getFamilyByCode('Langue')" chips
                @change="updateOrDeleteElement($event, 'langues')" deletable-chips label="Langues parlées"
                item-text="label" return-object multiple outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('Langue') && langues.length === 0 &&
             getField('Langue').skipped"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Langues parlées"
                            outlined>
            </v-autocomplete>

            <v-autocomplete v-if="hasFamilyElement('TypologiePromoSitra') &&
            (typoPromoApidae.length > 0 || !getField('TypologiePromoSitra').skipped)"
                            :value="typoPromoApidae" :items="getFamilyByCode('TypologiePromoSitra')" chips
                @change="updateOrDeleteElement($event, 'typoPromoApidae')" deletable-chips
                label="Typologie promo Apidae" item-text="label" return-object multiple outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('TypologiePromoSitra') && typoPromoApidae.length === 0 &&
             getField('TypologiePromoSitra').skipped"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Typologie promo Apidae"
                            outlined>
            </v-autocomplete>

            <v-autocomplete v-if="hasFamilyElement('DemarcheEcoResponsable') &&
            (demarcheEcoResponsable.length > 0 || !getField('DemarcheEcoResponsable').skipped)"
                            :value="demarcheEcoResponsable" :items="getFamilyByCode('DemarcheEcoResponsable')" chips
                @change="updateOrDeleteElement($event, 'demarcheEcoResponsable')" deletable-chips
                label="Démarche écoresponsable" item-text="label" return-object multiple outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('DemarcheEcoResponsable') &&
            demarcheEcoResponsable.length === 0 && getField('DemarcheEcoResponsable').skipped"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Démarche écoresponsable"
                            outlined>
            </v-autocomplete>

            <v-textarea v-if="hasField('DESC_TOURISME_DURABLE')" class="textarea" label="Tourisme durable"
                placeholder="Tourisme durable : Décrire ici vos pratiques pour le développement d'un tourisme soucieux de son impact environnemental, économique et social."
                :value="frenchDescSustainableTourism" @change="updateDescSustainableTourism" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_PORTRAIT')" class="textarea" label="Portrait" :value="frenchDescPortrait"
                @change="updateDescPortrait" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_2023_INNOVATION')" class="textarea" label="Nouveauté 2023"
                :value="frenchDesc2023Innovation" @change="updateDesc2023Innovation" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_2024_INNOVATION')" class="textarea" label="Nouveauté 2024"
                        :value="frenchDesc2024Innovation" @change="updateDesc2024Innovation" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_2025_INNOVATION')" class="textarea" label="Nouveauté 2025"
                        :value="frenchDesc2025Innovation" @change="updateDesc2025Innovation" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('OFFER_PROMOTIONS')" class="textarea" label="Offres promotionnelles"
                        :value="offerPromotions" @change="updateOfferPromotions" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_PARTY_MENU') && this.provider.category.name === 'RESTAURATION'"
                label="Menu spécial pour les fêtes" class="textarea" :value="frenchDescPartyMenu"
                @change="updateDescPartyMenu" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_GOOD_REASONS')" class="textarea" label="3 bonnes raisons de nous choisir"
                :value="frenchDescGoodReasons" @change="updateDescGoodReasons" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_ALERTE')" class="textarea" label="Alerte visiteurs"
                        :value="frenchAlerte" @change="updateAlerte" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_GIFT_CERTIFICATE')" class="textarea" label="Bon cadeau"
                        :value="frenchGiftCertificate" @change="updateGiftCertification" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_ADVICE_SUGG')" class="textarea" label="Conseils et suggestions"
                        :value="frenchAdvicesSuggestions" @change="updateAdvicesSuggestions" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_TAKEAWAY')" class="textarea" label="Vente à emporter"
                        :value="frenchTakeaway" @change="updateTakeaway" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_WINES_LABEL')" class="textarea" label='Label "Vignobles et Découvertes"'
                        :value="frenchWinesLabel" @change="updateWinesLabel" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_CHILD_SERVICE')" class="textarea" label="Services pour les enfants"
                        :value="frenchChildService" @change="updateChildService" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_CRUISERS_SERV')" class="textarea" label="Services pour les croisiéristes"
                        :value="frenchCruisersService" @change="updateCruisersService" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_CYCLIST_SERVICE')" class="textarea" label="Services pour les cyclistes"
                        :value="frenchCyclistService" @change="updateCyclistService" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_RIDERS_SERVICE')" class="textarea" label="Services pour les randonneurs"
                        :value="frenchRidersService" @change="updateRidersService" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_HIKERS_SERVICE')" class="textarea" label="Services pour les randonneurs"
                        :value="frenchHikersService" @change="updateHikersService" outlined>
            </v-textarea>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"
import _ from "lodash"

export default {
    name: "General",
    props: ['languages'],
    data() {
        return {
            moyenPaiements: [],
            langues: [],
            labelTourismeHandicap: [],
            demarcheEcoResponsable: [],
            typoPromoApidae: [],
            disabledReception: null
        }
    },
    methods: {
        ...mapMutations('web_form', [
            'updateContent', 'addElement', 'removeElement', 'updateProvider', 'updateBooleanElement', 'pushBooleanElement'
        ]),
        hasFieldToDisplay() {
            return this.hasField('OFFER_NAME') ||
                this.hasField('DESC_COURT_FR') ||
                this.hasField('DESC_LONG_FR') ||
                this.hasField('DESC_COURT_EN') ||
                this.hasField('DESC_LONG_EN') ||
                this.hasField('DESC_PORTRAIT') ||
                this.hasField('DESC_2024_INNOVATION') ||
                this.hasField('DESC_2025_INNOVATION') ||
                this.hasField('DESC_PARTY_MENU') && this.provider.category.name === "RESTAURATION" ||
                this.hasFamilyElement('ModePaiement') ||
                this.hasFamilyElement('Langue') ||
                this.hasFamilyElement('LabelTourismeHandicap') ||
                this.hasFamilyElement('DemarcheEcoResponsable') ||
                this.hasField('OFFER_PROMOTIONS') ||
                this.hasFamilyElement('TypologiePromoSitra') ||
                this.hasField('DESC_ALERTE') ||
                this.hasField('DESC_CRUISERS_SERV') ||
                this.hasField('DESC_ADVICE_SUGG') ||
                this.hasField('DESC_CHILD_SERVICE') ||
                this.hasField('DESC_CYCLIST_SERVICE') ||
                this.hasField('DESC_RIDERS_SERVICE') ||
                this.hasField('DESC_HIKERS_SERVICE') ||
                this.hasField('DESC_TAKEAWAY') ||
                this.hasField('DESC_WINES_LABEL')
        },
        getContentByLanguage(language) {
            return this.provider.contents.find(content => content.language.code === language)
        },
        setContents() {
            let contents = []

            this.languages.forEach(language => {
                let providerContent = this.getContentByLanguage(language.code)
                let shortContent = providerContent !== undefined ? providerContent.description : null
                let longContent = providerContent !== undefined ? providerContent.description_long : null
                let covidContent = providerContent !== undefined ? providerContent.description_theme_covid : null
                let sustainableContent = providerContent !== undefined ? providerContent.description_sustainable_tourism : null
                let portraitContent = providerContent !== undefined ? providerContent.description_portrait : null
                let innovation2023Content = providerContent !== undefined ? providerContent.description_2023_innovation : null
                let innovation2024Content = providerContent !== undefined ? providerContent.description_2024_innovation : null
                let innovation2025Content = providerContent !== undefined ? providerContent.description_2025_innovation : null
                let partyMenuContent = providerContent !== undefined ? providerContent.description_party_menu : null
                let goodReasonsContent = providerContent !== undefined ? providerContent.description_good_reasons : null
                let handiAuditifContent = providerContent !== undefined ? providerContent.desc_handi_auditif : null
                let handiMoteurContent = providerContent !== undefined ? providerContent.desc_handi_moteur : null
                let handiVisuelContent = providerContent !== undefined ? providerContent.desc_handi_visuel : null
                let handiMentalContent = providerContent !== undefined ? providerContent.desc_handi_mental : null
                let offerPromotions = providerContent !== undefined ? providerContent.offer_promotions : null
                let complementAccueil = providerContent !== undefined ? providerContent.complement_accueil : null
                let chef = providerContent !== undefined ? providerContent.chef : null
                let citqNumber = providerContent !== undefined ? providerContent.citq_number : null
                let alerte = providerContent !== undefined ? providerContent.alerte : null
                let cruisers_service = providerContent !== undefined ? providerContent.cruisers_service : null
                let gift_certificate = providerContent !== undefined ? providerContent.gift_certificate : null
                let advices_suggestions = providerContent !== undefined ? providerContent.advices_suggestions : null
                let child_service = providerContent !== undefined ? providerContent.child_service : null
                let cyclist_service = providerContent !== undefined ? providerContent.cyclist_service : null
                let riders_service = providerContent !== undefined ? providerContent.riders_service : null
                let hikers_service = providerContent !== undefined ? providerContent.hikers_service : null
                let takeaway = providerContent !== undefined ? providerContent.takeaway : null
                let wines_label = providerContent !== undefined ? providerContent.wines_label : null

                let content = {
                    language: language,
                    description: shortContent,
                    description_long: longContent,
                    description_theme_covid: covidContent,
                    description_sustainable_tourism: sustainableContent,
                    description_portrait: portraitContent,
                    description_2023_innovation: innovation2023Content,
                    description_2024_innovation: innovation2024Content,
                    description_2025_innovation: innovation2025Content,
                    description_party_menu: partyMenuContent,
                    description_good_reasons: goodReasonsContent,
                    desc_handi_auditif: handiAuditifContent,
                    desc_handi_moteur: handiMoteurContent,
                    desc_handi_visuel: handiVisuelContent,
                    desc_handi_mental: handiMentalContent,
                    offer_promotions: offerPromotions,
                    complement_accueil: complementAccueil,
                    chef: chef,
                    citq_number: citqNumber,
                    alerte: alerte,
                    cruisers_service: cruisers_service,
                    gift_certificate: gift_certificate,
                    advices_suggestions: advices_suggestions,
                    child_service: child_service,
                    cyclist_service: cyclist_service,
                    riders_service: riders_service,
                    hikers_service: hikers_service,
                    takeaway: takeaway,
                    wines_label: wines_label,
                }

                contents.push(content)
            })

            this.provider.contents = contents
        },
        updateOrDeleteElement(newElements, property) {
            let currentElements = this[property]

            if (currentElements.length > newElements.length) {  // Cas suppression
                this.deleteElement(currentElements, newElements)
            } else { // Cas Ajout
                this.addNewElement(currentElements, newElements)
            }

            this[property] = newElements
        },
        addNewElement(currentElements, newElements) {
            let element = newElements
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            if (Array.isArray(newElements)) {
                let diff = newElements.filter(_element => !previousValue.includes(_element)) || []

                if (diff.length) {
                    element = diff[diff.length - 1]
                }
            } else if (previousValue) {
                this.removeElement(previousValue)
            }

            this.addElement(element)
        },
        deleteElement(currentElements, newElements) {
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            const diff = previousValue.filter(element => {
                return !newElements.map(elt => elt.id).includes(element.id)
            }) || []

            let element = newElements

            if (diff.length) {
                element = diff[diff.length - 1]
            }

            this.removeElement(element)
        },
        updateDescSustainableTourism(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.description_sustainable_tourism = value
                }
            })
        },
        updateDescPortrait(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.description_portrait = value
                }
            })
        },
        updateDesc2023Innovation(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.description_2023_innovation = value
                }
            })
        },
        updateDesc2024Innovation(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.description_2024_innovation = value
                }
            })
        },
        updateDesc2025Innovation(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.description_2025_innovation = value
                }
            })
        },
        updateOfferPromotions(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.offer_promotions = value
                }
            })
        },
        updateDescPartyMenu(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.description_party_menu = value
                }
            })
        },
        updateDescGoodReasons(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.description_good_reasons = value
                }
            })
        },
        updateAlerte(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.alerte = value
                }
            })
        },
        updateCruisersService(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.cruisers_service = value
                }
            })
        },
        updateGiftCertification(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.gift_certificate = value
                }
            })
        },
        updateAdvicesSuggestions(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.advices_suggestions = value
                }
            })
        },
        updateChildService(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.child_service = value
                }
            })
        },
        updateCyclistService(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.cyclist_service = value
                }
            })
        },
        updateRidersService(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.riders_service = value
                }
            })
        },
        updateHikersService(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.hikers_service = value
                }
            })
        },
        updateTakeaway(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.takeaway = value
                }
            })
        },
        updateWinesLabel(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.wines_label = value
                }
            })
        },
    },
    computed: {
        ...mapState('web_form', ['provider', 'disabled']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode',
            'getField']),
        frenchDescSustainableTourism() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.description_sustainable_tourism
        },
        frenchDescPortrait() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.description_portrait
        },
        frenchDesc2023Innovation() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.description_2023_innovation
        },
        frenchDesc2024Innovation() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.description_2024_innovation
        },
        frenchDesc2025Innovation() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.description_2025_innovation
        },
        offerPromotions() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.offer_promotions
        },
        frenchDescPartyMenu() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.description_party_menu
        },
        frenchDescGoodReasons() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.description_good_reasons
        },
        frenchAlerte() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.alerte
        },
        frenchCruisersService() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.cruisers_service
        },
        frenchGiftCertificate() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.gift_certificate
        },
        frenchAdvicesSuggestions() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.advices_suggestions
        },
        frenchChildService() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.child_service
        },
        frenchCyclistService() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.cyclist_service
        },
        frenchRidersService() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.riders_service
        },
        frenchHikersService() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.hikers_service
        },
        frenchTakeaway() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.takeaway
        },
        frenchWinesLabel() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.wines_label
        },
    },
    watch: {
        provider: {
            handler: _.debounce(function () {
                this.updateProvider(this.provider)
            }, 200),
            deep: true
        }
    },
    created() {
        this.moyenPaiements = this.getElementsByFamilyCode('ModePaiement')
        this.langues = this.getElementsByFamilyCode('Langue')
        this.labelTourismeHandicap = this.getElementsByFamilyCode('LabelTourismeHandicap')
        this.demarcheEcoResponsable = this.getElementsByFamilyCode('DemarcheEcoResponsable')
        this.typoPromoApidae = this.getElementsByFamilyCode('TypologiePromoSitra')

        this.disabledReception = String(null)

        this.setContents()

        if (this.provider.boolean_elements !== null && this.provider.boolean_elements !== undefined) {
            let found = false

            this.provider.boolean_elements.forEach(booleanElement => {
                if (booleanElement.attribute.code === 'DISABLED_RECEPTION') {
                    this.disabledReception = booleanElement.value ?? String(booleanElement.value)

                    found = true
                }
            })

            if (!found) {
                let booleanElement = {
                    attribute: {
                        code: 'DISABLED_RECEPTION'
                    },
                    value: "null"
                }
                this.pushBooleanElement(booleanElement)
            }
        }
    }
}
</script>
